import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { GestockService } from '../../services/gestock.service';


declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}



const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

/* ADMIN
export const ROUTES: RouteInfo[] = [
    { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: '/homecpnt/agence', title: 'Comparateur',  icon:'content_paste', class: '' },
    { path: '/homecpnt/sousreseau', title: 'Sous-Réseau',  icon:'person', class: '' },
    { path: '/homecpnt/versement', title: 'Versements',  icon:'content_paste', class: '' },
    { path: '/homecpnt/appeldefonds', title: 'Appel De Fonds',  icon:'content_paste', class: '' },
    { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
    { path: '/homecpnt/partners', title: 'Partenaires',  icon: 'toc', class: '' },
    { path: '/homecpnt/packaging', title: 'Packaging',  icon:'view_column', class: '' },
    { path: '/homecpnt/comptafinances', title: 'Compta-Finances',  icon: 'money', class: '' },
    { path: '/homecpnt/avenants', title: 'Avenants',  icon:'settings', class: '' },
    { path: '/homecpnt/parametrage', title: 'Paramètrage',  icon:'settings', class: '' }
];
*/




@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  tampon = "";
  canOnlyPrepay = false;

  samacaabiyoonwii: any;

  existe = false;
  agencebi: any;
  logoUrl: string = '/assets/img/logodkmoto.png';

  constructor(private http: HttpClient, private router: Router, private gestockService: GestockService) {

    let allRoutes = JSON.parse(sessionStorage.getItem("yoonyifiam") || '[]');
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.agencebi = sessionStorage.getItem("agence");

    // Failsafe: ensure "Mon Shop" appears for authorized profiles even if session is stale
    let profil = sessionStorage.getItem("profil");
    if (profil && (profil.toLowerCase() === "caisse" || profil.toLowerCase() === "caissier")) {
      allRoutes = [
        { path: '/homecpnt/caisse', title: 'Gestion Caisse', icon: 'account_balance_wallet', class: '' },
        { path: '/homecpnt/recouvrement', title: 'Recouvrement', icon: 'warning', class: '' }
      ];
      sessionStorage.setItem("yoonyifiam", JSON.stringify(allRoutes));
    } else {
      const authorizedProfiles = ["ADMINISTRATEUR", "Gestionnaire Boutique", "Membre du Board", "Contrôleur de Gestion"];
      if (authorizedProfiles.includes(profil)) {
        if(!allRoutes.find(r => r.path === '/homecpnt/about')) {
          allRoutes.push({ path: '/homecpnt/about', title: 'Mon Shop', icon: 'info', class: '' });
        }
        if(!allRoutes.find(r => r.path === '/homecpnt/caisse')) {
          allRoutes.push({ path: '/homecpnt/caisse', title: 'Gestion Caisse', icon: 'account_balance_wallet', class: '' });
        }
        if(!allRoutes.find(r => r.path === '/homecpnt/banque')) {
          allRoutes.push({ path: '/homecpnt/banque', title: 'Banque & Versement', icon: 'account_balance', class: '' });
        }
        if(!allRoutes.find(r => r.path === '/homecpnt/credit-fournisseur')) {
          if (profil === "Gestionnaire Boutique" || profil === "ADMINISTRATEUR" || profil === "Contrôleur de Gestion") {
            allRoutes.push({ path: '/homecpnt/credit-fournisseur', title: 'Crédit Fournisseur', icon: 'local_shipping', class: '' });
          }
        }
        sessionStorage.setItem("yoonyifiam", JSON.stringify(allRoutes));
      }
    }

    if (this.canSeeReouvrement(allRoutes) == true)
      this.startRecouvrementChecker();

    this.menuItems = allRoutes.filter(menuItem => menuItem);
  }

  ngOnInit() {
    this.loadShopInfo();
  }

  loadShopInfo() {
    if (this.samacaabiyoonwii) {
      this.gestockService.getShopInfo(this.samacaabiyoonwii).then(res => {
        if (res && res.statutreq === 1 && res.data && res.data.logo) {
          this.logoUrl = res.data.logo.startsWith('/') || res.data.logo.startsWith('http') || res.data.logo.startsWith('assets/')
            ? res.data.logo
            : '/assets/img/' + res.data.logo;
        }
      }).catch(err => {
        console.error('Erreur chargement logo shop dans le sidebar:', err);
      });
    }
  }

  canSeeReouvrement(allRoutes) {
    for (var i = 0; i < allRoutes.length; i++) {
      if (allRoutes[i].title == "Recouvrement")
        return true;
    }
    return false;
  }


  startRecouvrementChecker() {
    // Exécute immédiatement une première fois
    this.checkRecouvrement();

    // Puis toutes les 10 minutes
    setInterval(() => {
      this.checkRecouvrement();
    }, 5 * 60 * 1000); // 10 minutes en ms
  }

  checkRecouvrement() {
    this.gestockService.hasClientARecouvrer(this.samacaabiyoonwii).then(retour => {
      this.existe = retour;
      if (this.existe) {
        console.log("Au moins un recouvrement en attente !");
        // ici tu peux aussi afficher une notification visuelle si besoin
      }
    });
  }



  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };


  isOnlyPrepaidAuthorized(compliances) {
    let allOfThem = JSON.parse(compliances);
    this.canOnlyPrepay = false;
    for (var i = 0; i < allOfThem.length; i++) {
      if (allOfThem[i].name == "solde_impaye")
        this.canOnlyPrepay = Number(allOfThem[i].valeur) <= 0;
    }
  }


  disconnect() {
    this.tampon = sessionStorage.getItem("samacaabiyoonwii");

    sessionStorage.clear();
    localStorage.clear();

    this.guennGueew();
    this.router.navigate(['/']);
  }

  guennGueew() {
    let logooutData = { samacaabiyoonwii: this.tampon };
    this.remotelogger('https://dkm.sentelecom.com/gestion/guenngueew.php', logooutData).subscribe(
      retourPost => {
        this.tampon = "";
      });
  }

  remotelogger(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }


}
